import { clearCookie, getCookie, setCookie } from "./cookies";

export type AuthUser = {
    id: string;
    name: string;
    role: string;
    handover_department_id?: string;
};

export function homeRoute(user: AuthUser | null) {
    return !user ? "/login" : user.role === "Handover" ? "/handover" : user.role === "HAP" ? "/hap" : "/beds";
}

export function getSessionExpiry(): number | null {
    const value = getCookie("session_expires_at");
    if (!value) {
        return null;
    }

    const expiresAt = Date.parse(value);
    return Number.isFinite(expiresAt) ? expiresAt : null;
}

export function getAuthUser(): AuthUser | null {
    const id = getCookie("user_id");
    if (!id) {
        return null;
    }

    return {
        id,
        name: getCookie("user_name") || id,
        role: getCookie("user_role") || "Manager",
    };
}

export function setAuthUser(user: AuthUser) {
    setCookie("user_id", user.id);
    setCookie("user_name", user.name);
    setCookie("user_role", user.role);
}

export function clearAuthUser() {
	clearCookie("user_id");
	clearCookie("user_name");
	clearCookie("user_role");
	clearCookie("access_token");
	clearCookie("refresh_token");
	clearCookie("session_expires_at");
}
